module.exports = fox._r("images/bg/btn_yellow.png", __webpack_public_path__ + "images/bg/btn_yellow.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-file-loader!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/file-loader?name=[path][name].[ext]!./images/bg/btn_yellow.png
// module id = 1011
// module chunks = 4